interface StatsCommon {
  total: number;
}

interface HubStats extends StatsCommon {
  online: number;
  offline: number;
  unassigned: number;
}

interface AdherenceStats {
  non_adherent: number;
  unknown: number;
  adherent: number;
}

interface SoftwareStats {
  up_to_date: number;
  need_updating: number;
  unknown: number;
}

interface IssuesStats extends StatsCommon {
  high_priority: number;
  low_priority: number;
}

interface PatientSurveyStats {
  very_unhappy: number;
  somewhat_unhappy: number;
  somewhat_happy: number;
  very_happy: number;
}

// Patients bucketed by their latest daily wellness-check score (1-5).
// Optional: absent from backends older than OmcareRestServer OI-1772.
export interface DailyWellnessStats {
  very_bad: number;
  bad: number;
  neutral: number;
  good: number;
  very_good: number;
}

interface StatsCategory {
  hubs: HubStats;
  adherence: AdherenceStats;
  software: SoftwareStats;
  issues: IssuesStats;
  patient_survey: PatientSurveyStats;
  daily_wellness?: DailyWellnessStats;
}

export interface FacilityOverviewStatsResponse {
  devices: Array<{ id: number; customer_id: number; facility_id: number }>;
  adherence: { adherent: number; unknown: number; nonAdherent: number };
  survey_scores: Array<{
    last_name: string;
    first_name: string;
    customer_id: number;
    facility_id: number;
    latest_survey_score: number;
    latest_wellness_score?: number | null;
  }>;
  online_devices: Array<{ device_id: number }>;
  facility_issues: Array<any>;
  patient_survey: {
    very_unhappy: number;
    somewhat_unhappy: number;
    somewhat_happy: number;
    very_happy: number;
  };
  daily_wellness?: DailyWellnessStats;
  issues: { high_priority: number; low_priority: number };
  hubs: { online: number; offline: number; unassigned: number; total: number };
  software_version_info: Array<any>;
  software: { Unknown?: number; up_to_date?: number; need_updating?: number };
  stable_channel_software_version: string;
}

export interface OverviewStatsResponse {
  stable_channel_software_version: string;
  facilities: StatsCategory;
  consumers: StatsCategory;
  all: StatsCategory;
}

export type AnyOverviewStatsResponse =
  OverviewStatsResponse | FacilityOverviewStatsResponse;

export interface OverviewStatsStore {
  stats: AnyOverviewStatsResponse | null;
  error: any | null;
  isLoading: boolean;
}

export enum OverviewStatsActionTypes {
  FETCH_STATS_SUCCESS = 'FETCH_STATS_SUCCESS',
  FETCH_STATS_FAILURE = 'FETCH_STATS_FAILURE',
  SET_LOADING = 'SET_LOADING',
}

export type OverviewStatsAction =
  | {
      type: OverviewStatsActionTypes.FETCH_STATS_SUCCESS;
      payload: OverviewStatsResponse;
    }
  | { type: OverviewStatsActionTypes.FETCH_STATS_FAILURE; payload: any }
  | { type: OverviewStatsActionTypes.SET_LOADING; payload: boolean };
